import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type PickerMode = 'manual' | 'auto';
export type BulkStrategy = 'cheapest' | 'mid' | 'premium' | 'recommended';

interface TireOfferPickerState {
  selectedQuoteItemId: Record<number, number>;
  mode: PickerMode;
  bulkStrategy: BulkStrategy;
  selectedAddressId: number | undefined;

  selectOption: (tireSetOfferId: number, quoteItemId: number) => void;
  setSelection: (next: Record<number, number>) => void;
  clearSelection: () => void;
  setMode: (mode: PickerMode) => void;
  setBulkStrategy: (strategy: BulkStrategy) => void;
  setSelectedAddressId: (id: number | undefined) => void;
}

export const useTireOfferPickerStore = create<TireOfferPickerState>()(
  devtools((set) => ({
    selectedQuoteItemId: {},
    mode: 'manual',
    bulkStrategy: 'cheapest',
    selectedAddressId: undefined,

    selectOption: (tireSetOfferId, quoteItemId) =>
      set((state) => {
        const next = { ...state.selectedQuoteItemId };
        if (next[tireSetOfferId] === quoteItemId) {
          delete next[tireSetOfferId];
        } else {
          next[tireSetOfferId] = quoteItemId;
        }
        return { selectedQuoteItemId: next };
      }),
    setSelection: (next) => set({ selectedQuoteItemId: next }),
    clearSelection: () => set({ selectedQuoteItemId: {}, selectedAddressId: undefined }),
    setMode: (mode) => set({ mode }),
    setBulkStrategy: (bulkStrategy) => set({ bulkStrategy }),
    setSelectedAddressId: (selectedAddressId) => set({ selectedAddressId })
  }))
);
